import { Component, OnInit } from '@angular/core';
import {
  ParametrosImprimirAdmisionEntity,
  EntidadEmpresarial,
  InformacionUsuarioEntity,
  ServicioImprimirAdmisionService,
  EmpresaAdmision
} from 'src/app/services/servicio-imprimir-admision.service';
import { ActivatedRoute } from '@angular/router';
import {
  ServicioSolicitudMedicamentosPendientesService,
  ObjectSolicitudMedicamentosPendientesRequest,
  AfiliadoOrdenMedicaEntity
} from 'src/app/services/servicio-solicitud-medicamentos-pendientes.service';

@Component({
  selector: 'app-reporte-solicitud-pendiente-medicamentos',
  templateUrl: './reporte-solicitud-pendiente-medicamentos.component.html',
  styleUrls: ['./reporte-solicitud-pendiente-medicamentos.component.css']
})
export class ReporteSolicitudPendienteMedicamentosComponent implements OnInit {
  private parametrosUrl: ParametrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: '',
    uncoAdmision: ''
  };

  public errorDataReporte = false;
  public loading = true;
  public error = false;
  public diagnosticos: any[] = [];
  public dataKeys: any[] = [];
  public dataReporte: any;
  public uncoEmpresa: string;
  public empresa: string;
  public fechaImpresion: Date = new Date();
  public listaEmpresas: EmpresaAdmision[] = [];
  public dataEntidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: ''
  };
  public dataAfiliado: AfiliadoOrdenMedicaEntity = {
    identificacion: '',
    historiaClinica: '',
    nombre: '',
    fechaNacimiento: '',
    direccion: '',
    telefono: '',
    tipoAfiliado: '',
    sexo: '',
    estrato: '',
    edad: '',
    empresa: '',
    sede: '',
    admision: ''
  };
  public dataUsuario: InformacionUsuarioEntity = {
    nombreUsuario: '',
    codigoBarrasImprime: ''
  };

  constructor(
    private servicioAdmision: ServicioImprimirAdmisionService,
    private servicioSolicitud: ServicioSolicitudMedicamentosPendientesService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.parametrosUrl.codigoBaseDatos = params.codigoBaseDatos;
      this.parametrosUrl.uncoSede = params.uncoSede;
      this.parametrosUrl.uncoLogin = params.uncoLogin;
      this.parametrosUrl.uncoAdmision = params.uncoAdmision;
    });
  }

  ngOnInit() {
    this.getFilterEmpresas();
    this.getInfoUsuario();
    this.getInfoEntidadEmpresarial();
  }

  public getEmpresa(uncoEmpresa: string) {
    if (uncoEmpresa !== undefined) {
      this.listaEmpresas.forEach(empresa => {
        if (empresa.uncoEmpresa.toString() === uncoEmpresa) {
          this.uncoEmpresa = uncoEmpresa;
          this.empresa = empresa.descripcionEmpresa;

          if (uncoEmpresa !== undefined) {
            this.getInfoAfiliado(uncoEmpresa);
          }
        }
      });
    }
  }

  public getGenerar() {
    this.getDataSolicitudMedicamentos(this.uncoEmpresa);
  }

  public getPrint() {
    window.print();
  }

  /*  Consumo de los servicios */

  private async getFilterEmpresas() {
    const response = await this.servicioAdmision.getEmpresasAdmision(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if ( data !== null && data !== [] ) {
        this.listaEmpresas = data;
      }
      // console.log(data);
    }, error => {
      this.error = true;
      console.log(error);
    });
  }

  private async getInfoUsuario() {
    const response = await this.servicioAdmision.getInformacionUsuario(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataUsuario = data[0];
      }
      // console.log(this.dataUsuario);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getInfoEntidadEmpresarial() {
    const response = await this.servicioAdmision.getEntidadEmpresarial(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataEntidadEmpresarial = data[0];
      }
      // console.log(this.dataEntidadEmpresarial);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getInfoAfiliado( uncoEmpresa: string ) {
    const response = await this.servicioSolicitud.getAfiliadoOrdenMedica(this.parametrosUrl.codigoBaseDatos, this.parametrosUrl.uncoAdmision);

    response.subscribe( (data: any) => {
      if ( data !== null ) {
        this.dataAfiliado = data;
        this.getDataSolicitudMedicamentos(uncoEmpresa);
      }
      // console.log(this.dataAfiliado);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getDataSolicitudMedicamentos( uncoEmpresa: string ) {
    const params: ObjectSolicitudMedicamentosPendientesRequest = {
      codigoBaseDatos: this.parametrosUrl.codigoBaseDatos,
      uncoAdmision: this.parametrosUrl.uncoAdmision,
      uncoEmpresa: uncoEmpresa
    };
    const response = await this.servicioSolicitud.getDataSolicitudMedicamentosPendientes(params);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataKeys = Object.keys(data);
        this.dataReporte = data;
        this.loading = false;
        // console.log(data);
      }
      // console.log(this.dataEntidadEmpresarial);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

}
